<template>
	<div class="affiliate-promo-code">
		<div class="titlebar">
			<h2 class="h5 h-alter" v-text="$__('profile.text.affiliate.codes')"></h2>

			<div class="links">
				<a :href="$__('profile.affiliate.change_link')" :title="$__('profile.text.request.change')" v-text="$__('profile.text.request.change')"></a>
				<a :href="$__('profile.affiliate.help_link')" :title="$__('profile.text.request.change')" v-text="$__('profile.text.help')"></a>
			</div>
		</div>

		<div class="promo-codes-wrapper">
			<span v-if="copied" v-text="$__('profile.affiliate.copied')"></span>
			<div class="row">
				<div class="col-md-8 empty"></div>
				<div class="col-md-4">
					<div class="info-main">
						<div v-text="$__('profile.affiliate.expiration_date')"></div>
						<div v-text="$__('profile.affiliate.coupon_earnings')"></div>
					</div>
				</div>
			</div>
			<div class="single" v-for="(coupon, index) in coupons" :key="coupon.id">
				<div class="row align-items-md-center">
					<div class="col-md-8 content">
						<div class="code">
							<input readonly="readonly" type="text" :value="coupon.code">
							<button class="btn btn-plain btn-clipboard" @click="copyCode"><svg class="ticon"><use xlink:href="/images/icons.svg#icon-link"></use></svg></button>
						</div>
						<div class="info">
							<p v-text="coupon.description"></p>
						</div>
					</div>

					<div class="col-md-4 payout">
						<div class="info">
							<div class="date">{{ coupon.valid_until | formatDate }}</div>
							<div class="amount">{{ coupon.earnings | formatCurrency(coupon.locale) }}</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "Coupons",
	props: {
		coupons: Array
	},
	data() {
		return {
			copied: false
		}
	},
	methods: {
		copyCode(event) {
			const urlValue = event.currentTarget.previousElementSibling;
			urlValue.select();
			urlValue.setSelectionRange(0, 99999);
			document.execCommand("copy");
			this.copied = true;
			let $this = this;
			setTimeout(function() {
				$this.copied = false;
			}, 80000);
		}
	}
}
</script>
